module.exports = __webpack_public_path__ + "img/lindii.12b26ca4.jpg";